import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isObject } from '@seiue/util';
import styled from 'styled-components';
/**
 * 自定义标签头
 *
 * @param props - props
 * @param props.tabBarExtraContent - 标签头上额外的元素
 * @param props.style - 标签头样式
 * @returns React.ReactElement
 */
export const CustomTabBar = ({ children, tabBarExtraContent, style }) => {
    if (!tabBarExtraContent)
        return _jsx(_Fragment, { children: children }, void 0);
    if (isObject(tabBarExtraContent) &&
        ('left' in tabBarExtraContent || 'right' in tabBarExtraContent)) {
        const { left, right } = tabBarExtraContent;
        return (_jsxs(Wrapper, Object.assign({ style: style }, { children: [!left ? null : _jsx(Extra, { children: left }, void 0), _jsx(Content, { children: children }, void 0), !right ? null : _jsx(Extra, { children: right }, void 0)] }), void 0));
    }
    return (_jsxs(Wrapper, Object.assign({ style: style }, { children: [children, _jsx(Extra, { children: tabBarExtraContent }, void 0)] }), void 0));
};
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const Content = styled.div `
  flex: 1;
`;
const Extra = styled.div `
  flex: none;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3VzdG9tVGFiQmFyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL1RhYnMvQ3VzdG9tVGFiQmFyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLGFBQWEsQ0FBQTtBQUV0QyxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQTtBQUl0Qzs7Ozs7OztHQU9HO0FBQ0gsTUFBTSxDQUFDLE1BQU0sWUFBWSxHQUdwQixDQUFDLEVBQUUsUUFBUSxFQUFFLGtCQUFrQixFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUU7SUFDL0MsSUFBSSxDQUFDLGtCQUFrQjtRQUFFLE9BQU8sNEJBQUcsUUFBUSxXQUFJLENBQUE7SUFFL0MsSUFDRSxRQUFRLENBQUMsa0JBQWtCLENBQUM7UUFDNUIsQ0FBQyxNQUFNLElBQUksa0JBQWtCLElBQUksT0FBTyxJQUFJLGtCQUFrQixDQUFDLEVBQy9EO1FBQ0EsTUFBTSxFQUFFLElBQUksRUFBRSxLQUFLLEVBQUUsR0FBRyxrQkFBa0IsQ0FBQTtRQUUxQyxPQUFPLENBQ0wsTUFBQyxPQUFPLGtCQUFDLEtBQUssRUFBRSxLQUFLLGlCQUNsQixDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxLQUFDLEtBQUssY0FBRSxJQUFJLFdBQVMsRUFDckMsS0FBQyxPQUFPLGNBQUUsUUFBUSxXQUFXLEVBQzVCLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLEtBQUMsS0FBSyxjQUFFLEtBQUssV0FBUyxhQUMvQixDQUNYLENBQUE7S0FDRjtJQUVELE9BQU8sQ0FDTCxNQUFDLE9BQU8sa0JBQUMsS0FBSyxFQUFFLEtBQUssaUJBQ2xCLFFBQVEsRUFDVCxLQUFDLEtBQUssY0FBRSxrQkFBa0IsV0FBUyxhQUMzQixDQUNYLENBQUE7QUFDSCxDQUFDLENBQUE7QUFFRCxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFBOzs7O0NBSXpCLENBQUE7QUFFRCxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFBOztDQUV6QixDQUFBO0FBRUQsTUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQTs7Q0FFdkIsQ0FBQSJ9